<template>
    <span
        v-if="itemId"
        :class="{ 'wishlist-icon': !is_in_wishlist }"
        :style="{
            color: is_in_wishlist ? color : '',
        }">
        <svg-icon :key="wishlistIcon" :name="wishlistIcon" width="32" height="32" @click="toggleWishlist" />
    </span>

    <nuxt-link v-else to="/lk/favorites/" :aria-label="$t('favorites')">
        <svg-icon
            :key="wishlistIcon"
            :name="wishlistIcon"
            :style="{
                color: wishlist.length ? color : '',
            }"
            width="32"
            height="32" />
    </nuxt-link>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
    name: "WishlistHeart",
    props: {
        itemId: {
            type: [Number, Boolean],
            default: false,
        },
        itemSlug: {
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            wishlist: "wishlist/getIds",
        }),
        wishlistIcon() {
            if (this.itemId) {
                return this.is_in_wishlist ? "wishlist--fill" : "wishlist";
            }

            return this.wishlist.length ? "wishlist--fill" : "wishlist";
        },
        is_in_wishlist() {
            return this.$store.getters["wishlist/checkId"](this.itemId);
        },
        color() {
            let color = "currentColor";
            if (this.itemId) {
                if (this.is_in_wishlist) color = "#FF002A";
            } else {
                color = "#FF002A";
            }
            return color;
        },
    },
    methods: {
        ...mapActions({
            setIds: "wishlist/setIds",
            addItemToDb: "wishlist/addItemToDb",
        }),
        async addItem(item) {
            await this.addItemToDb(item);
        },
        async deleteItem(item) {
            await this.$store.dispatch("wishlist/deleteItemFromDb", item);
        },

        toggleWishlist() {
            let gender = "all";
            if (this.$route.query.gender) {
                gender = this.$route.query.gender;
            }
            if (["catalog-man", "catalog-man-all"].includes(this.$route.name)) {
                gender = "man";
            }
            if (["catalog-woman", "catalog-woman-all"].includes(this.$route.name)) {
                gender = "woman";
            }

            const productLink = `https://post-post-scriptum.com/product/${this.itemSlug}/?gender=${gender}`;

            // if (this.$auth.loggedIn) {
            if (this.is_in_wishlist) {
                this.deleteItem(this.itemId);
                window.$sendRetailCRMEvent("click", {
                    el: `wishlist.remove ${productLink}`,
                });
            } else {
                this.addItem(this.itemId);
                window.$sendRetailCRMEvent("click", {
                    el: `wishlist.add ${productLink}`,
                });
            }
            this.setIds();
            // } else {
            //     this.$nuxt.$emit("show-wl-notify");
            // }
        },
    },
};
</script>
<style lang="less" scoped>
a,
span {
    cursor: pointer;
    display: block;
    user-select: none;

    svg {
        display: block;
        + div {
            margin-left: 2px;
            .is_apple & {
                padding-top: 2px;
            }
        }
    }
}
.is_animated {
    position: relative;
    &::before {
        content: "";
        display: block;
        position: absolute;
        width: 4px;
        height: 4px;
        animation: pulse 0.45s ease-out;
        border-radius: 50%;
        left: 14px;
        top: 13px;
        z-index: 1;
        background: #000;
    }
    svg {
        position: relative;
        z-index: 2;
    }
}
@keyframes pulse {
    0% {
        transform: scale(1);
        background: @accent;
    }
    30% {
        transform: scale(6.5);
    }
    100% {
        transform: scale(10);
        background: transparent;
    }
}
.wishlist-icon {
    transition: color 0.3s ease;
    @media @notsm {
        &:hover {
            color: @red2 !important;
        }
    }
}
</style>
